import { Box, Grid } from "@mui/material"
import { FilterNonIdeal, InnerWrapper, MainContainer, TitleAndActionBox } from "../../../../common"
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../../../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { handleApi } from "../../../../../apis";
import { EXPORTGETSTATEMENT } from "../../../../../apis/configuration";
import BusinessLoader from "../../../../common/BusinessLoader";
import { AppPagination } from "../../../../../Libraries";
import StatementItemList from "./StatementItemList";
import TableHeader from "./TableHeader";
import styles from "./../AllTransaction.module.css";
import ConfirmationModal from "../../../../common/Modals/ConfirmationModal";
import NonIdealNew from "../../../../common/NonIdealNew";

const CustomStatement = () => {
    const [I18n] = useContext(LanguageContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true);
    const [statement, setStatment] = useState([]);
    const [totalReport, setTotalReport] = useState(0);
    const [page, setPage] = useState(1);

    useEffect(() => {
        fetchBankStatement();
    }, []);

    const fetchBankStatement = async (page = 1) => {
        setLoading(true);
        if (page === 1) setInitialLoading(true)
        const resp = await handleApi(EXPORTGETSTATEMENT, { limit: 15, page })
        setStatment(
            page == 1
                ? [...resp?.reports]
                : [...statement, ...resp?.reports],
        );
        setTotalReport(resp?.total_reports || 0)
        setLoading(false);
        setInitialLoading(false)
    }

    return (
        <MainContainer fluid className="quickSalePage">
            <BusinessLoader loadBusiness={initialLoading} />
            <Grid container>
                <Grid item md={12}>
                    <TitleAndActionBox
                        data={{
                            title: I18n.custom_statements,
                            isBack: true,
                            onBack: () => navigate(-1),
                            id: "bank_statement",
                        }}
                    >

                    </TitleAndActionBox>
                    <InnerWrapper className="innerWrapper newInnerWrapper">
                        <TableHeader />
                        {statement.length > 0 ? (
                            <Box
                                className={`${styles.ViewStatementContainer} generic-scrollbar`}
                                id="scrollableDiv"
                            >
                                <AppPagination
                                    data={{
                                        handleNext: (e) => {
                                            setPage((page) => {
                                                if (statement.length < totalReport) {
                                                    fetchBankStatement(page + 1);
                                                    return page + 1;
                                                }
                                                return page;
                                            });
                                        },
                                        pageLoad: loading,
                                        count: totalReport,
                                        list: statement,
                                        scrollableTarget: "scrollableDiv",
                                    }}
                                >
                                    {statement.map((item) => (
                                        <StatementItemList item={item} key={item?.id} onRefetch={
                                            () => {
                                                fetchBankStatement(1)
                                                setPage(1)
                                            }
                                        } />
                                    ))}
                                </AppPagination>
                            </Box>)
                            : <NonIdealNew
                                title={`${I18n.no_available_statements}`}
                                subtitle={`${I18n.no_available_statements_subtitle}`}
                            />
                        }
                    </InnerWrapper>
                </Grid>
            </Grid>
          
        </MainContainer>
    )
}

export default CustomStatement;